angular.module('iqxCore')
.controller('AgencyContactCtrl', function ($scope, FormSvc, $location) {
	$scope.checkPermissions('AGENCY')
    FormSvc.setOptions($scope,{
      fetchAPI:'callresult/NetAgencyContact',
      saveAPI:'call/NetAgencyContactSet',
      savePrefix:'p',
      primaryKey:'employmentid'
    })

  $scope.changepassword=function(){
    $location.path('/changepassword')
  }
      
  $scope.doUpdate=function () {  // Over-ride the default update() called by the Save & Submit button
    FormSvc.setSubmitted($scope,true)
    return FormSvc.update($scope, false, false)  // Do not do the fetch if submitted
    .then(function(err) {
      if (!err) {
        FormSvc.alert("Saved", "Your details have been updated.", "success")
      }      
    })
    .catch(function(err){
      // Catch if a user is trying to change their email address to one that already exists!!
      if(err.iqxError.text === "[FireDAC][Phys][ODBC][SAP][ODBC Driver][SQL Anywhere]Index 'IQXNetUserEmailAddress' for table 'IQXNetUser' would not be unique"){
        FormSvc.alert('An account may already exist with that email address.','Please contact us to resolve this.','error')
      }
    })
  }
  $scope.update=$scope.doUpdate
  $scope.fetch()
    
})
